import { makeStyles } from '@material-ui/core/styles';
import { IconButton } from '@material-ui/core';
import { DropRightIcon } from '../../../../components/Icon';
import { i18n } from '../../../../language';
import { onKeyUpEnterOrSpace } from '../../../../utils';
import Header from './head';

const useStyles = makeStyles((theme) => ({
  title: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1.125rem',
    lineHeight: '1.625rem',
    color: theme.palette.font.main,
    fontWeight: '500',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  body: {
    padding: '1.125rem 1.25rem',
    display: 'flex',
    justifyContent: 'space-between',
    height: '3.75rem',
    borderBottom: '0.0625rem solid #e4e7eb',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  rightbtn: {
    borderRadius: '0',
    width: '1.5rem',
    height: '1.5rem',
    '&:hover': {
      backgroundColor: theme.palette.font.white,
    },
  },
  righticon: {
    fontSize: '0.875rem',
    color: theme.palette.primary.main,
  },
}));

export default function Filter({ backOnclick, groupOnclick, timeOnclick }) {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Header backOnclick={backOnclick} title={i18n.t('DUTYASSIGN_STAFF_FILTER')} />
      <div
        className={classes.body}
        id="DutyAssign-div-abu"
        onClick={groupOnclick}
        tabIndex={0}
        onKeyUp={(e) => onKeyUpEnterOrSpace(e, groupOnclick)}
      >
        <div className={classes.title}>{i18n.t('DUTYASSIGN_ROSTER_FILTER_GROUP')}</div>
        <IconButton className={classes.rightbtn}>
          <DropRightIcon className={classes.righticon} />
        </IconButton>
      </div>
      <div
        className={classes.body}
        onClick={timeOnclick}
        id="DutyAssign-div-abv"
        tabIndex={0}
        onKeyUp={(e) => onKeyUpEnterOrSpace(e, timeOnclick)}
      >
        <div className={classes.title}>{i18n.t('DUTYASSIGN_ROSTER_FILTER_TIME')}</div>
        <IconButton className={classes.rightbtn}>
          <DropRightIcon className={classes.righticon} />
        </IconButton>
      </div>
    </div>
  );
}
